import AgoraRTC, { LocalStreamStats, RemoteStreamStats } from "agora-rtc-sdk";
import { firebaseFunctionHost } from "../../config/fetch";
function initStream(stream: AgoraRTC.Stream): Promise<any> {
  return new Promise((resolve, reject) => {
    stream.init(
      () => {
        resolve();
      },
      (err) => {
        reject(err);
      }
    );
  });
}

function initClient(client: AgoraRTC.Client, appId: string): Promise<any> {
  return new Promise((resolve, reject) => {
    client.init(
      appId,
      () => {
        resolve();
      },
      (err) => {
        reject(err);
      }
    );
  });
}

function join(
  client: AgoraRTC.Client,
  token: string,
  channel: string,
  uid: string
): Promise<number | string> {
  return new Promise((resolve, reject) => {
    client.join(
      token,
      channel,
      uid,
      (uid) => {
        resolve(uid);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

function getDevices(
  agoraRtc: typeof AgoraRTC
): Promise<AgoraRTC.MediaDeviceInfo[]> {
  return new Promise((resolve, _) => {
    agoraRtc.getDevices((devices) => resolve(devices));
  });
}

export async function createStreamerAccessToken(
  conferenceId: string
): Promise<string> {
  const response = await fetch(
    `${firebaseFunctionHost}/conferences/${conferenceId}/create-streamer-access-token`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        appId: "07b1090fa235439ea8bea276e23f3d74",
        channelName: conferenceId,
      }),
    }
  );
  const responseJson = await response.json();
  return responseJson.accessToken;
}

export async function createAudienceAccessToken(
  conferenceId: string
): Promise<string> {
  const response = await fetch(
    `${firebaseFunctionHost}/conferences/${conferenceId}/create-audience-access-token`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        appId: "07b1090fa235439ea8bea276e23f3d74",
        channelName: conferenceId,
      }),
    }
  );
  const responseJson = await response.json();
  return responseJson.accessToken;
}
export async function initAgoraStreamer(
  option: AgoraOption,
  agoraRtc: typeof AgoraRTC
) {
  const client = agoraRtc.createClient({ mode: "live", codec: "h264" });
  await initClient(client, option.appId);
  client.setClientRole("host");
  const accessToken = await createStreamerAccessToken(option.channel);
  const uid = await join(client, accessToken, option.channel, option.uid);

  const stream = agoraRtc.createStream({
    streamID: uid,
    audio: true,
    video: true,
    screen: false,
  });
  await initStream(stream);
  const devices = await getDevices(agoraRtc);
  return { client, stream, devices, uid };
}
export async function initAgoraScreenSharingStream(
  option: AgoraOption,
  agoraRtc: typeof AgoraRTC
): Promise<{
  client: AgoraRTC.Client;
  stream: AgoraRTC.Stream;
  err?: any;
}> {
  const client = agoraRtc.createClient({ mode: "live", codec: "h264" });
  await initClient(client, option.appId);
  client.setClientRole("host");
  const accessToken = await createStreamerAccessToken(option.channel);
  await join(client, accessToken, option.channel, option.uid);

  const stream = agoraRtc.createStream({
    streamID: option.uid,
    audio: false,
    video: false,
    screen: true,
    screenAudio: true,
  });
  try {
    await initStream(stream);
  }
  catch(err) {
    return { err, client, stream }
  }
  return { client, stream };
}

export function isLocalStreamStats(
  arg: LocalStreamStats | RemoteStreamStats
): arg is LocalStreamStats {
  return (arg as LocalStreamStats).audioSendBytes !== undefined;
}

export async function initAgoraAudience(
  agoraRtc: typeof AgoraRTC,
  option: AgoraOption
) {
  const client = agoraRtc.createClient({ mode: "live", codec: "h264" });
  await initClient(client, option.appId);
  client.setClientRole("audience");
  const accessToken = await createAudienceAccessToken(option.channel);
  await join(client, accessToken, option.channel, option.uid);
  return { client };
}
